// extracted by mini-css-extract-plugin
module.exports = {"container":"SyncButton_container__3av5B","icon":"SyncButton_icon__1ANcA"};